import React from 'react';
import { Text } from 'components';
const VendorWithoutValidContactTooltipContent = () => (React.createElement(Text.Regular, null, "Email address required to request tax information."));
export default VendorWithoutValidContactTooltipContent;
